import React from 'react'
import _ from 'lodash';
import ExpandTableComponent from '../components/expand-table.component';

export  function ExpandTableContainer  ({subRowData,isExpand,subRowDataId,subColumnDefs,row,columnData,handleExpandTableEdit,handleExpandTableDelete}: any) {
      const subFilteredFields = _.filter(
        subColumnDefs,
        (item) => item.field !== 'Sl'
      )
  
      
  return (
    <>
 <ExpandTableComponent 
subRowDataId={subRowDataId}
row={row}
isExpand={isExpand}
handleExpandTableEdit={handleExpandTableEdit}
handleExpandTableDelete={handleExpandTableDelete}
columnData={columnData}
subFilteredFields={subFilteredFields}
subRowData={subRowData}
subColumnDefs={subColumnDefs}
 />

 </>
  )
}
